<template>
  <div class="studies-map">
    <div class="table-buttons">
      <router-link :to="{ name: 'Table', params: { state: 'ALL' } }">
        <button class="table-button" id="all-studies-button">
          <md-icon class="md-size">table_chart</md-icon>All studies
        </button>
      </router-link>
      <router-link :to="{ name: 'Table', params: { state: 'unmapped' } }">
        <button class="table-button" id="unmapped-studies-button">
          <md-icon class="md-size">table_chart</md-icon>Unmapped studies
        </button>
      </router-link>
      <router-link :to="{ name: 'Table', params: { state: 'regional' } }">
        <button class="table-button">
          <md-icon class="md-size">table_chart</md-icon>Regional studies
        </button>
      </router-link>
    </div>
    <div v-if="studies.length > 0">
      <highcharts
        constructorType="mapChart"
        class="hc"
        :options="chartOptions"
        ref="chart"
      ></highcharts>
    </div>
    <div class="fixed-credits-container">
      <a href="http://zevross.com/" class="about-this-map-link"
        >Map application created by ZevRoss Spatial Analysis</a
      >
    </div>
  </div>
</template>

<script>
import router from "../router";
import seeuropeJson from "../data/se_europe.geo.json";
import kosovoJson from "../data/kosovo_line.geo.json";

export default {
  name: "hei-studies-map",
  props: ["studies", "studiesByType"],

  data: function() {
    return {
      chartOptions: {
        title: {
          text: "",
        },
        chart: {
          backgroundColor: "#d4e9f6",
          style: {
            fontFamily: "'Fira Sans', sans-serif",
          },
        },
        colorAxis: {
          min: 0,
          minColor: "#c1dee6",
          maxColor: "#226273",
        },
        plotOptions: {
          series: {
            events: {
              click: function(e) {
                router.push(`/table/${e.point["hc-key"]}`);
              },
            },
            states: {
              inactive: {
                opacity: 1,
              },
            },
          },
        },
        mapNavigation: {
          enabled: false,
          buttonOptions: {
            align: "right",
          },
        },
        tooltip: {
          formatter() {
            let point = this;

            return `<b>${point.point.properties.name}</b> <br> <p>Total studies: ${point.point.value}</p>`;
          },
        },
        legend: {
          title: {
            text:
              'Total studies per country<br/><span style="font-size: 9px; color: #666; font-weight: normal"></span>',
          },
          align: "right",
          verticalAlign: "bottom",
          backgroundColor: "#fff",
          borderRadius: "4px",
          shadow: true,
          floating: true,
          width: 250,
          padding: 15,
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                series: [
                  {
                    dataLabels: {
                      allowOverlap: false,
                    },
                  },
                  {},
                  {},
                ],
              },
            },
          ],
        },
        series: [
          {
            cursor: "pointer",
            mapData: seeuropeJson,
            name: "Total studies",
            dataLabels: {
              enabled: true,
              allowOverlap: false,
              format: "{point.properties.name}",
            },
            borderColor: "slategray",
            borderWidth: 1,
            data: [],
          },
          {
            mapData: kosovoJson,
            name: "Disputed borders",
            type: "mapline",
            showinLegend: false,
            dataLabels: {
              enabled: false,
            },
            lineWidth: 1.5,
            dashStyle: "shortdot",
            nullColor: "white",
            data: [],
          },
        ],
      },
    };
  },
  watch: {
    studies() {
      this.chartOptions.series[0].data = this.studies;
    },
  },
};
</script>

<style lang="scss">
.studies-map {
  position: relative;
}
.table-buttons {
  z-index: 100;
  padding: 5px;
  position: absolute;
  display: flex;
  max-width: 70vw;
  justify-content: flex-start;
  left: 0px;
  flex-flow: row wrap;
  #all-studies-button,
  #unmapped-studies-button {
    margin-right: 5px;
  }
  .table-button {
    display: flex !important;
    align-items: center !important;
    // height: 100% !important;
    margin-bottom: 5px;
    .md-icon,
    .md-size {
      font-size: 18px !important;
      width: 18px;
      min-width: 18px;
      height: 18px;
      margin-right: 8px;
    }
    i {
      color: white !important;
      margin-right: 3px;
      font-size: 15px !important;
    }
  }
}

a:hover:not(.about-this-map-link) {
  text-decoration: none !important;
}

.highcharts-series-1,
.highcharts-series-2 {
  path {
    pointer-events: none;
  }
}

@media only screen and (min-width: 500px) {
  .table-buttons {
    top: 0px;
    left: 0;
  }
}

@media only screen and (max-width: 500px) {
  .table-buttons {
    top: 0px;
    right: 0;
  }
}
</style>
